import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertService, AuthService } from '@shared/services';
import { map } from 'rxjs/operators';
import { RouteService } from '@shared/services';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class CommunityBankService {
  constructor(
    protected http: HttpClient,
    public alertService: AlertService,
    private authService: AuthService,
    private routeService: RouteService,
  ) {}

  initialize(token: string) {
    this.authService.flush();

    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token);

    const auth = {
      token,
      ...decodedToken,
      customerFullName: `${decodedToken.firstName} ${decodedToken.lastName}`,
    };

    this.authService.auth = auth;
    this.routeService.isInitialized$.next(true);
    localStorage.setItem('transaction', JSON.stringify(auth));
    return auth;
  }

  // Merchant-side call: only the /test page (?community=JPY) uses it to start a
  // community transaction locally. Real customers arrive with a token from the merchant.
  initializeTransaction(request: any): Observable<any> {
    const url = '/api/v2/checkout/communitybank/initialize';
    return this.http.post<any>(url, request);
  }

  getBanks(): Observable<any> {
    const url = `/api/v2/communityBankTransferCheckout/banks`;
    const request = { country: this.authService.auth?.country };
    return this.http.post<any>(url, request).pipe(
      map((response) => {
        if (response.availableBanks) {
          return response.availableBanks;
        } else {
          throw new HttpErrorResponse({
            error: response,
            url,
          });
        }
      }),
    );
  }

  getAmounts(request: any): Observable<any> {
    const url = `/api/v2/communityBankTransferCheckout/availableAmount`;
    return this.http.post<any>(url, request).pipe(
      map((response) => {
        if (response.activeAmount) {
          return response.activeAmount;
        } else {
          throw new HttpErrorResponse({
            error: response,
            url,
          });
        }
      }),
    );
  }
}
